export default __webpack_public_path__ + "static/media/GithubLogo.d30db950.svg";